import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "snt-page-detail-header-emoji",
  template: "",
  standalone: false
})
export class PageDetailHeaderEmojiComponent {
  @Input() emojis: string | undefined;
  @Output() add: EventEmitter<string> = new EventEmitter();
  @Output() clear: EventEmitter<void> = new EventEmitter();
}
